import React from "react";

function CameraIcon() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.48893 12.1556C10.9617 12.1556 12.1556 10.9617 12.1556 9.48893C12.1556 8.01617 10.9617 6.82227 9.48893 6.82227C8.01617 6.82227 6.82227 8.01617 6.82227 9.48893C6.82227 10.9617 8.01617 12.1556 9.48893 12.1556Z"
        stroke="#424242"
        strokeWidth="1.2"
      />
      <path
        d="M0.600098 9.81207C0.600098 7.08763 0.600098 5.72586 1.26587 4.74808C1.55527 4.32319 1.92558 3.95952 2.35565 3.67786C2.99565 3.25742 3.79742 3.1072 5.02498 3.05387C5.61075 3.05387 6.11475 2.61831 6.22942 2.05387C6.31705 1.64042 6.54473 1.2699 6.87399 1.00494C7.20326 0.739975 7.6139 0.596814 8.03652 0.599651H10.9414C11.8196 0.599651 12.5761 1.20854 12.7485 2.05387C12.8632 2.61831 13.3672 3.05387 13.953 3.05387C15.1796 3.1072 15.9814 3.25831 16.6223 3.67786C17.0534 3.96053 17.4241 4.32409 17.7121 4.74808C18.3778 5.72586 18.3778 7.08763 18.3778 9.81207C18.3778 12.5365 18.3778 13.8974 17.7121 14.8761C17.4227 15.301 17.0523 15.6646 16.6223 15.9463C15.6258 16.5996 14.2383 16.5996 11.4641 16.5996H7.51386C4.73964 16.5996 3.35209 16.5996 2.35565 15.9463C1.92582 15.6643 1.5558 15.3003 1.26676 14.8752C1.07364 14.5875 0.931423 14.2688 0.846319 13.933M15.7112 6.82186H14.8223"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default CameraIcon;
